function normalizeArray(value) {
  return Array.isArray(value)
    ? value.filter(Boolean).map((item) => String(item).trim()).filter(Boolean)
    : [];
}

export function normalizeAccessPayload(access) {
  const payload = access && typeof access === 'object' ? access : {};
  const list = normalizeArray(payload.list);
  return {
    ...payload,
    list,
    set: new Set(list)
  };
}

export function hasCapability(access, key, fallback = true) {
  const wanted = String(key || '').trim();
  if (!wanted) return Boolean(fallback);
  const normalized = normalizeAccessPayload(access);
  if (!normalized.list.length) return Boolean(fallback);
  if (normalized.set.has('*') || normalized.set.has(wanted)) return true;

  // Support wildcard prefixes like module.tasks.*
  const segments = wanted.split('.');
  while (segments.length > 1) {
    segments.pop();
    if (normalized.set.has(`${segments.join('.')}.*`)) return true;
  }
  return false;
}

export function buildCapabilityHelpers(access, fallback = true) {
  return {
    access,
    can: (key) => hasCapability(access, key, fallback)
  };
}
